/**
 * Gets random AI features to display on auth pages
 * Selects 3 features randomly from the pool on each call
 */

export interface AIFeature {
  icon: string;
  translationKey: string;
}

const AI_FEATURES: AIFeature[] = [
  { icon: '✨', translationKey: 'branding.features.aiWorkflows' },
  { icon: '🤖', translationKey: 'branding.features.smartAutomation' },
  { icon: '⚡', translationKey: 'branding.features.instantInsights' },
  { icon: '🎯', translationKey: 'branding.features.intelligentPlanning' },
  { icon: '🧠', translationKey: 'branding.features.contextualSuggestions' },
  { icon: '🔮', translationKey: 'branding.features.predictiveAnalytics' },
  { icon: '💡', translationKey: 'branding.features.smartRecommendations' },
  { icon: '🚀', translationKey: 'branding.features.autoOptimization' },
  { icon: '🎨', translationKey: 'branding.features.adaptiveUI' },
  { icon: '🔄', translationKey: 'branding.features.continuousLearning' },
];

/**
 * Randomly selects 3 unique features from the pool
 */
export function getRandomFeatures(): AIFeature[] {
  const shuffled = [...AI_FEATURES].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, 3);
}
